// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__36xYu","footer":"ModalInfo_footer__1yhE_"};